Librarian.Modules.Uploads = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-uploads-",
        orderBy: "FileDBImportDate",
        order: "desc",
        count: 5,
        showDate: false,
        dateFormat: "%m/%d/%Y"
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl || !Librarian.specialCategories || (typeof Librarian.specialCategories.UserUploads != "number"))
            return;

        this.parent();

        // Create the container element and generate the URL
        var listEl = new Element("ul").injectInside(this.containerEl),
            url = Librarian.path.getMethodUrl("getfiles") + "&out=ujson&orderBy=" + this.options.orderBy + "&order=" + this.options.order + "&perpage=" + this.options.count + "&cid=" + Librarian.specialCategories.UserUploads;

        this.request = new Librarian.Request.JSON({
            url: url,
            onSuccess: function (json) {
                if (!json)
                    return;

                listEl.empty();

                // Get the list of files, but make sure there are some before we continue
                var files = json.Files;
                if (!files || (files.length == 0))
                    return;

                // Create a line for each of the files
                for (var i = 0; i < files.length; i++) {
                    var file = files[i],
                        date = Librarian.Utils.extractDateFromString(file.ImportDate).format(this.options.dateFormat);

                    // Create the list item and link for this file
                    var listItemEl = new Element("li", {
                        "class": (this.options.classPrefix || '') + "item"
                    }).injectInside(listEl);
                    new Element("a", {
                        "class": (this.options.classPrefix || '') + "link",
                        "text": this.options.showDate ? (date + " - " + file.Name) : file.Name,
                        "title": file.Name,
                        "href": Librarian.path.getDownloadUrl("dnld") + "&fid=" + file.FileId,
                        "target": "_download"
                    }).injectInside(listItemEl);
                }
            }.bind(this),
            onFailure: Librarian.Utils.onFailure
        });
        this.request.send();
    }
});